export const isLogin = state => state.isLogin;
export const carCount = state => state.carCount;



// WEBPACK FOOTER //
// ./src/vuex/getters.js